import React from "react";

const stats: [string, string][] = [
  ["10,841", "REGIONS ON-CHAIN"],
  ["8", "CATALOGS INDEXED"],
  ["3", "DATA AUTHORITIES"],
  ["∞", "FOREVER VERIFIABLE"],
];

export default function TokenBand() {
  return (
    <section id="token" className="sec-pad token-sec" data-screen-label="Token">
      <div className="wrap token-grid">
        <div data-reveal>
          <div className="sec-tag">
            <span className="idx">[ 08 ]</span> GOVERNANCE <span className="rule"></span>
          </div>
          <h2 className="h-md">A registry owned by its explorers.</h2>
          <p className="lead token-lead">
            NiftySky is stewarded as a DAO. Deed-holders shape the catalogs we onboard, the science we partner with, and the treasury that funds it all.
          </p>
          <a className="btn btn-ghost" href="/token">READ THE TOKEN PAPER →</a>
        </div>
        <div className="token-stats" data-reveal>
          {stats.map((s, i) => (
            <div className="token-stat panel ticks" key={i}>
              <div className="token-v tnum">{s[0]}</div>
              <div className="token-l mono">{s[1]}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
